import type React from 'react';

import { useImpactStoryPageData } from '#src/app/pages/impactStory/pageContext';

import { PageBody } from '../components/PageBody';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC<EmptyProps> = () => {
	const {
		data: {
			petition: { slug },
		},
	} = useImpactStoryPageData();

	useTrackPageView(slug);

	return <PageBody />;
};
